import { render, staticRenderFns } from "./ManageGroupOfDiscountBox.vue?vue&type=template&id=f7303c68&"
import script from "./ManageGroupOfDiscountBox.vue?vue&type=script&lang=js&"
export * from "./ManageGroupOfDiscountBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports